<!-- 新增编辑框 -->
<template>
  <a-modal
    :title="title"
    width="1000px"
    :visible="visible"
    @ok="onSave"
    @cancel="onClose"
    v-if="visible"
  >
    <a-form-model
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      :colon="false"
      class="drawer-view"
    >
      <a-row :gutter="20">
        <a-col span="12">
          <a-form-model-item label="用户类型" prop="userType">
            <SelectModule
              v-model="ruleForm.userType"
              apiType="getDictDataByCode"
              :apiParams="{ dictCode: 'use_type' }"
              @change="handleUserType"
              :showAll="true"
            />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="姓名" prop="userRealName">
            <InputText v-model="ruleForm.userRealName" allowClear />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="20">
        <a-col span="12">
          <a-form-model-item
            label="UkeyID"
            v-if="ruleForm.userType != '0'"
            :prop="ruleForm.userType != '0' ? 'userKey' : 'empty'"
          >
            <InputText v-model="ruleForm.userKey" allowClear />
          </a-form-model-item>
          <a-form-model-item
            label="账号"
            v-if="ruleForm.userType == '0'"
            :prop="ruleForm.userType == '0' ? 'loginAccount' : 'empty'"
          >
            <InputText v-model="ruleForm.loginAccount" allowClear />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="所属机构" prop="orgName">
            <LenovoSelectModule
              :reset="true"
              placeholder="请输入"
              v-model="ruleForm.orgName"
              apiType="getPubOrganName"
              modelKey="name"
              :paramsListObj="{ name: 'name', id: 'id' }"
              @change="handleOrg"
              :disabled="title == '编辑'"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="20">
        <a-col span="12">
          <a-form-model-item label="所属部门" prop="departmentName">
            <InputText v-model="ruleForm.departmentName" allowClear />
            <!-- <LenovoSelectModule
              :reset="true"
              placeholder="请输入"
              v-model="ruleForm.departmentName"
              apiType="getPubDeptName"
              modelKey="name"
              :paramsListObj="{ name: 'name', id: 'id' }"
              @change="handleDepart"
            /> -->
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="身份证号" prop="userIdCard">
            <!-- :disabled = "title == '编辑' && !!defaultParams.userIdCard" -->
            <InputText
              v-model="ruleForm.userIdCard"
              allowClear
              
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="20">
        <a-col span="12">
          <a-form-model-item label="手机号" prop="phone">
            <InputText v-model="ruleForm.phone" allowClear />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="状态" prop="accountStatus">
            <SelectModule
              v-model="ruleForm.accountStatus"
              apiType="getDictDataByCode"
              :apiParams="{ dictCode: 'account_status' }"
              :showAll="true"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="20">
        <a-col span="12">
          <a-form-model-item label="角色" prop="roleIds" class="user-role">
            <!-- autoValue="roleId"
              autoLabel="roleName" -->
            <SelectModule
              v-model="ruleForm.roleIds"
              mode="multiple"
              notFoundContent="暂无数据"
              :selectData="selectData"
              :disabled="!ruleForm.orgName"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>

    <template slot="footer">
      <a-button @click.stop="onReset">清空</a-button>
      <a-button @click.stop="onClose">取消</a-button>
      <a-button type="primary" @click.stop="onSave">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import InputText from "@/components/form/InputText"; // 输入框组建
import SelectModule from "@/components/form/SelectModule"; // 下拉组件
import LenovoSelectModule from "@/components/form/LenovoSelectModule"; // 联想下拉
import API from "@/api/sysManage.js"; // 请求接口
import SELECTAPI from "@/api/select.js";
export default {
  components: {
    InputText,
    SelectModule,
    LenovoSelectModule,
  },
  props: {
    // 表格选中数据
    modalData: {
      type: Object,
      required: false,
    },
    modalFlag: Boolean,
  },
  computed: {
    title() {
      let str = "";
      if (JSON.stringify(this.modalData) != "{}") {
        str = "编辑";
      } else {
        str = "新增";
      }
      return str;
    },
  },
  data() {
    // 统一社会信用代码/身份证号 - 校验
    const checkSfz = (rule, value, callback) => {
      let _IDRe18 =
        /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      // 校验身份证
      if (value === "") {
        callback(new Error("请输入身份证号!"));
      } else if (!_IDRe18.test(value)) {
        callback(new Error("请输入正确的格式"));
      } else {
        callback();
      }
    };
    const checkPhone = (rule, value, callback) => {
      let telephone = /^1[3-9][0-9]{9}$/; // 手机
      if (value === "") {
        callback(new Error("请输入手机号!"));
      } else if (!telephone.test(value)) {
        callback(new Error("请输入正确的格式"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        id: "", // 主键ID
        userType: "0",
        userRealName: "",
        userKey: "",
        orgName: "",
        orgId: "",
        departmentName: "",
        departmentId: "",
        userIdCard: "",
        phone: "",
        roleIds: [],
        accountStatus: "0",
        loginAccount: "",
      },
      rules: {
        userType: [
          { required: true, message: "请输入用户类型!", trigger: "change" },
        ],
        userRealName: [
          { required: true, message: "请输入姓名!", trigger: "change" },
        ],
        userKey: [
          { required: true, message: "请输入UkeyID!", trigger: "change" },
        ],
        loginAccount: [
          // { required: true, message: "请输入账号!", trigger: "change" },
          { required: true, validator: this.validateName, trigger: "change"},
        ],
        orgName: [
          { required: true, message: "请选择所属机构!", trigger: "change" },
        ],
        departmentName: [
          { required: true, message: "请输入所属部门!", trigger: "change" },
        ],
        userIdCard: [
          { required: true, validator: checkSfz, trigger: "change" },
        ],
        phone: [{ required: true, validator: checkPhone, trigger: "change" }],
        accountStatus: [
          { required: true, message: "请选择状态!", trigger: "change" },
        ],
        roleIds: [
          { required: true, message: "请选择角色!", trigger: "change" },
        ],
      },
      visible: false,
      isShowUser: false, // 是否显示账号
      defaultParams: {},
      selectData: [],
      apiType: "loadRoleList",
    };
  },
  methods: {
    // 关闭
    onClose() {
      this.$emit("handleFlag", false);
    },
    handleUserType(data) {
      this.isShowUser = data == "0" ? true : false;
    },
    // 选择机构
    handleOrg(name, obj) {
      this.ruleForm.orgId = obj ? obj.id : "";
      this.ruleForm.orgName = obj ? obj.name : "";
      if(!obj) {
        this.ruleForm.roleIds = []
      }
      if(obj && obj.name) {
        this.getSelectOption(obj.orgLevelCode)
      }
    },
    handleDepart(name, obj) {
      this.ruleForm.departmentId = obj ? obj.id : "";
      this.ruleForm.departmentName = obj ? obj.name : "";
    },
    // 获取角色详情
    getDetail() {
      let params = {
        data: {
          params: {
            id: this.ruleForm.id,
            isAdmin: "0",
          },
        },
      };
      API.loadUserById(params, (callback) => {
        let data = {};
        if (callback.status == "S" && callback.data) {
          data = callback.data;
          this.defaultParams = data;
          for (let key in this.ruleForm) {
            if (data.hasOwnProperty(key)) {
              if (key == "roleIds") {
                let arr = [];
                data.pubUserRoles.map((item) => {
                  arr.push(item.roleId);
                });
                this.ruleForm[key] = arr || [];
              } else {
                this.ruleForm[key] = data[key] || "";
              }
            }
          }

          this.getSelectOption(callback.data.orgLevelCode)
        }
      });
    },
    // 获取角色列表
    getSelectOption(code) {
      let paramsObj = {
        data: {
          params: {
            orgLevelCode: code || '',
          },
        },
      };
      SELECTAPI[this.apiType](paramsObj, (callback) => {
        let list = [];
        if (callback.status == "S" && callback.data) {
          if (Array.isArray(callback.data) && callback.data.length > 0) {
            callback.data.map((item, index) => {
              list.push({
                id: item.roleId,
                name: item.roleName,
              });
            });
          }
        }
        this.selectData = list;
      });
    },

    // 保存
    onSave() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.submit();
        }
      });
    },
    submit() {
      this.loading = true;
      let params = {
        data: {
          params: {
            // id: this.modalData.id || "",
            ...this.ruleForm,
            isAdmin: "0",
          },
        },
      };
      API.mergeUser(params, (callback) => {
        this.loading = false;
        if (callback.status == "S") {
          let str = "";
          if (JSON.stringify(this.modalData) != "{}") {
            str = "编辑成功";
          } else {
            str =
              "新增成功，账号初始密码：TYDL_gj2023，请及时登录系统进行密码修改！";
          }
          this.$alert(str)
          // this.$message.destroy();
          // this.$message.success(`${str}`);
          this.$emit("handleFlag", false, {}, "ok");
        }
      });
    },
    onReset() {
      this.ruleForm = {
        id: "", // 主键ID
        userType: "0",
        userRealName: "",
        userKey: "",
        orgName: "",
        orgId: "",
        departmentName: "",
        departmentId: "",
        userIdCard: "",
        phone: "",
        accountStatus: "0",
        loginAccount: "",
        roleIds: [],
      };
    },
    validateName(rule, value) {
      if(!value) {
        return Promise.reject('请输入账号');
      } else if (/[\u4e00-\u9fa5]/.test(value)) {
        return Promise.reject('不能输入中文,请重新输入');
      } else {
        return Promise.resolve();
      }
    }
  },
  watch: {
    // 模态框开关
    modalFlag(newVal, oldVal) {
      this.visible = newVal;
      this.selectData = [];
      if (newVal) {
        this.ruleForm.id = this.modalData.id || "";
        if (JSON.stringify(this.modalData) != "{}") {
          // 编辑
          this.getDetail();
        }
      } else {
        this.ruleForm = {
          id: "", // 主键ID
          userType: "0",
          userRealName: "",
          userKey: "",
          orgName: "",
          orgId: "",
          departmentName: "",
          departmentId: "",
          userIdCard: "",
          phone: "",
          accountStatus: "0",
          loginAccount: "",
          roleIds: [],
        };
      }
    },
  },
};
</script>

<style scoped lang="less">
.drawer-view {
  .user-role {
    /deep/.ant-form-item-control {
      height: auto;
      max-height: 300px;
      .ant-select-selection--multiple {
        height: auto;
        max-height: 300px;
        overflow-y: auto;
      }
    }
  }
}
</style>
